import { createSelector } from 'reselect'
import { globalOptions } from 'Core/constants'

export const getActiveTip = createSelector(
  state => state && state.user && state.user.registration && state.user.registration.activeTip
    ? state.user.registration.activeTip : globalOptions.defaultTip,
  tip => tip
)
